import { MarketResponse } from '../../Interfaces/api/backoffice/market.interface';

export class Market {
  id = '';
  code: string | null = null;
  name: string | null = null;
  currency: string | null = null;
  region_scope: string | null = null;
  is_default = false;
  is_active = false;

  constructor(data: Partial<MarketResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.code || this.id;
  }
}
